// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content. 

import { enableMapSet } from "immer";
import authReducer from "@slices/authSlice/auth";
import userReducer from "@slices/userSlice/user";
import teamsReducer from "@slices/teamsSlice/teams";
import topicsReducer from "@slices/topicsSlice/topics";
import leadsReducer from "@slices/leadsSlice/leads";
import organizationsReducer from "@slices/organizationsSlice/organizations";
import repositoryRequestReducer from "@slices/repositoryRequestSlice/repositoryRequest";
import defaultTeamsReducer from "@slices/defaultTeamSlice/defaultTeams";
import commentsReducer from "./commentSlice/comment";
import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "@slices/commonSlice/common";
import employeeReducer from "@slices/employeeSlice/employee";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

enableMapSet();

export const store = configureStore({
  reducer: {
    repositoryRequest: repositoryRequestReducer,
    auth: authReducer,
    user: userReducer,
    common: commonReducer,
    employee: employeeReducer,
    teams: teamsReducer,
    topics: topicsReducer,
    leads: leadsReducer,
    organizations: organizationsReducer,
    comments: commentsReducer,
    defaultTeams: defaultTeamsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: undefined,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
